const eventNames = {
    componentDidSubmit: {
        filters: 'Filters.componentDidSubmit',
        timeSlots: 'TimeSlots.componentDidSubmit',
        collectInformation: 'CollectInformation.componentDidSubmit',
        confirmation: 'Confirmation.componentDidSubmit',
    },
}

export default eventNames


// WEBPACK FOOTER //
// ./actions/eventNames.js